import { useTranslation } from "react-i18next";

import { IRuleAwakeConditions } from "interfaces/rules.interface";

import { InfoField } from "./InfoField";

type LogPresetAwakeProps = {
  preset: IRuleAwakeConditions;
  state?: string;
};

export function LogPresetAwake({ preset, state }: LogPresetAwakeProps) {
  const { t } = useTranslation();

  return (
    <>
      <InfoField
        label={t("minimum_time_presence_is")}
        value={(preset.initial_presence_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
      <InfoField
        label={state === "ok" ? t("time_asleep_since") : t("time_awake_is")}
        value={(preset.ok_to_alert?.awake_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
    </>
  );
}
